import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

/**
 * 
 * @param {*} props {match, labels, contents}
 * @returns 
 */

export default function MyTabs(props) {
    const [value, setValue] = React.useState(0);
    let { match, labels, contents } = props
    if (!labels)
        labels = []
    if (!contents)
        contents = []

    console.log(match.path)

    // if (!labels || !contents)
    //     throw 'Empty labels or contents!!!'

    // if (labels.length !== contents.length)
    //     throw 'Length of labels and contents put into tabs must match!!!'

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs id="Tabs" className="white-text" value={value} onChange={handleChange} >
                    {labels.map((label, index) => <Tab className="Tab" label={label} {...a11yProps(index)} />)}
                    {/* <Tab className="Tab" label="About" {...a11yProps(0)} />
                    <Tab className="Tab" label="Ladder" {...a11yProps(1)} />
                    <Tab className="Tab" label="New Match" {...a11yProps(2)} />
                    <Tab className="Tab"
                        label={<Badge badgeContent={mypendings.length} color="error">
                            Pending
                        </Badge>}
                        {...a11yProps(3)} /> */}
                </Tabs>
            </Box>

            {contents.map((content, index) => <TabPanel value={value} index={index}>
                {content}
            </TabPanel>)}
            {/* <TabPanel value={value} index={0}>
                <AboutLadder ></AboutLadder>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <StickyHeadTable match={match}></StickyHeadTable>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <AddMatch></AddMatch>
            </TabPanel>
            <TabPanel value={value} index={3}>

                <PendingMatch></PendingMatch>
            </TabPanel> */}
        </Box>
    );
}
